import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, Text, TextArea } from '@reveni-io/reveni-ui'

import IssueReasonSelector from './IssueReasonSelector/IssueReasonSelector'
import * as Styles from './styles'

const MarkAsIssuedModal = ({ show, onClose, onMarkAsIssued, markingAsIssued, amount, language, currency }) => {
  const { t } = useTranslation()
  const [notes, setNotes] = useState('')
  const [issueReason, setIssueReason] = useState('')

  useEffect(() => {
    if (!show) {
      setNotes('')
      setIssueReason('')
    }
  }, [show])

  return (
    <Modal show={show} onClose={onClose} title={t('Marcar reembolso como emitido')} size="l">
      <Styles.MainContainer>
        <Text type="bodyMRegular">
          {t('Elige un motivo para poder guardar cambios y marcar el reembolso pendiente ({{amount}}) como emitido', {
            amount: new Intl.NumberFormat(language, {
              style: 'currency',
              currency: currency || 'EUR',
            }).format(amount),
          })}
        </Text>
        <IssueReasonSelector value={issueReason} onChange={e => setIssueReason(e.target.value)} />
        <Styles.NotesContainer>
          <Text type="titleS">{t('Notas')}</Text>
          <TextArea
            fullWidth
            label={t('Escribe aquí los comentarios')}
            value={notes}
            onChange={e => setNotes(e.target.value)}
            showCounter={true}
            maxLength={100}
          />
        </Styles.NotesContainer>
        <Alert type="warning">{t('Esta acción no se podrá deshacer más adelante. ¿Quieres continuar?')}</Alert>
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Aceptar')}
            loadingLabel={t('Guardando cambios')}
            onClick={() => onMarkAsIssued(notes, issueReason)}
            loading={markingAsIssued}
            disabled={markingAsIssued || !notes || !issueReason}
          />
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Modal>
  )
}

export default MarkAsIssuedModal
